import TrashIcon from '../TrashIcon';

interface Location {
  x: number;
  y: number;
}

interface IProps {
  locationTextNode: Location;
  locationImageNode: Location;
  handleDeleteActiveText: () => void;
  handleDeteleActiveImage: () => void;
  isText: boolean;
}

const ModalDelete = ({
  locationTextNode,
  locationImageNode,
  handleDeleteActiveText,
  handleDeteleActiveImage,
  isText
}: IProps) => {
  const { x, y } = isText ? locationTextNode : locationImageNode;
  return (
    <button
      style={{
        top: y - 40,
        left: x
      }}
      className="bg-white px-4 py-1 rounded position-absolute btn"
      onClick={isText ? handleDeleteActiveText : handleDeteleActiveImage}
    >
      <TrashIcon height={20} width={15} />
    </button>
  );
};

export default ModalDelete;
